<template>
  <div>
    <div class="user-management-container">
      <el-button style="margin-bottom: 20px" @click="goBack">返回</el-button>
      <el-form :inline="true" :model="queryForm" @submit.prevent>
        <el-form-item>
          <el-input v-model.trim="queryForm.keyword" clearable placeholder="请输入名称" />
        </el-form-item>
        <!-- <el-form-item label="企业:">
            <el-select
              v-model="queryForm.enterpriseCode"
              @change="queryData"
              clearable
            >
              <template v-for="(item, index) in enterPriseList" :key="index">
                <el-option
                  :value="item.enterpriseCode"
                  :label="item.enterpriseName"
                ></el-option>
              </template>
</el-select>
</el-form-item> -->
        <el-form-item>
          <el-button :icon="Search" type="primary" @click="queryData">查询</el-button>
        </el-form-item>
      </el-form>
      <vab-query-form>
        <vab-query-form-left-panel :span="24">
          <el-form :label-position="labelPosition" :model="queryForm" @submit.prevent>
            <el-form-item label="状态" label-width="100px" style="margin: 0 0 10px 0 !important">
              <ul class="radioBox">
                <li
                  v-for="(item, index) in userTypeList"
                  :key="index"
                  :class="[queryForm.auditStatus == item.key ? 'isChecked' : '']"
                  @click="selectChange('userType', item.key)"
                >
                  {{ item.name }}
                </li>
              </ul>
            </el-form-item>
            <el-form-item label="用户身份" label-width="100px" style="margin: 0 0 10px 0 !important">
              <ul class="radioBox">
                <li
                  v-for="(item, index) in officalCountList"
                  :key="index"
                  :class="[queryForm.identity == item.identity ? 'isChecked' : '']"
                  @click="selectChange('officalCount', item.identity)"
                >
                  {{ item.name }}
                </li>
              </ul>
            </el-form-item>
            <el-form-item label="是否存在审核通过的会议活动" label-width="200px" style="margin: 0 0 10px 0 !important">
              <ul class="radioBox">
                <li
                  :class="[queryForm.isExistAuditPassForum == true ? 'isChecked' : '']"
                  @click="selectChange('isExistAuditPassForum', !queryForm.isExistAuditPassForum)"
                >
                  是
                </li>
                <!-- <li @click="selectChange('isExistAuditPassForum', false)" :class="[queryForm.isExistAuditPassForum ==  false? 'isChecked' : '']">否</li> -->
              </ul>
              <!-- <el-switch  @change="selectChangeBySwitch" v-model="queryForm.isExistAuditPassForum" size="large" active-text="是" inactive-text="否" /> -->
            </el-form-item>
            <el-form-item
              v-if="checkUserList.length > 0 && queryForm.identity"
              label="批量操作"
              label-width="100px"
              style="margin: 0 0 10px 0 !important"
            >
              <template v-if="queryForm.auditStatus == 'PENDING_REVIEW'">
                <el-button type="primary" @click="accept">通过</el-button>
                <el-button type="danger" @click="dialogFormVisible1 = true">不通过</el-button>
              </template>

              <template v-if="queryForm.auditStatus == 'ACCEPT'">
                <el-button type="danger" @click="dialogFormVisible1 = true">不通过</el-button>
              </template>

              <template v-if="queryForm.auditStatus == 'REFUSE'">
                <el-button type="primary" @click="accept">通过</el-button>
              </template>

              <el-switch
                v-model="isSendMsg"
                active-text="发送"
                inactive-text="不发送"
                size="large"
                style="margin-left: 10px"
              />
            </el-form-item>
          </el-form>
        </vab-query-form-left-panel>
      </vab-query-form>

      <!-- -->
      <el-table v-loading="listLoading" border :data="list" @selection-change="handleSelectionChange">
        <el-table-column v-if="queryForm.auditStatus != 'CANCEL_SIGN'" type="selection" width="55" />
        <el-table-column align="center" label="用户姓名" prop="name" show-overflow-tooltip />
        <el-table-column align="center" label="公司/机构" prop="submitTime">
          <template #default="{ row }">
            {{ row.organization ? row.organization : '/' }}
          </template>
        </el-table-column>
        <el-table-column align="center" label="职位" prop="submitTime">
          <template #default="{ row }">
            {{ row.position ? row.position : '/' }}
          </template>
        </el-table-column>
        <el-table-column align="center" label="身份">
          <template #default="{ row }">
            <span style="color: #2196f3">{{ identityMap[row.identity] }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="状态" prop="submitTime">
          <template #default="{ row }">
            <span :style="'color: ' + getStatusColor(row.status)">{{ statusList[row.status] }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="提交时间" prop="submitTime">
          <template #default="{ row }">
            {{ handleDate(row.submitTime) }}
          </template>
        </el-table-column>
        <el-table-column align="center" fixed="right" label="操作" show-overflow-tooltip>
          <template #default="{ row }">
            <el-button type="primary" @click="handleEdit(row)">查看详情</el-button>
          </template>
        </el-table-column>
        <template #empty>
          <el-empty class="vab-data-empty" description="暂无数据" />
        </template>
      </el-table>
      <el-pagination
        background
        :current-page="queryForm.pageNum"
        :layout="layout"
        :page-size="queryForm.pageSize"
        :total="total"
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
      />
      <edit ref="editRef" :meeting-code="queryForm.meetingCode" @fetch-data="fetchData" />
    </div>

    <el-drawer ref="drawerRef" v-model="dialogFormVisible1" :append-to-body="true" :size="size1" title="填写驳回原因">
      <el-form ref="reasonRef" :model="form" :rules="rules">
        <el-form-item label="原因">
          <el-input v-model="form.reason" type="textarea" />
        </el-form-item>
        <el-form-item align="center">
          <el-button size="large" type="primary" @click="refuse">提交</el-button>
        </el-form-item>
      </el-form>
    </el-drawer>
  </div>
</template>

<script>
  import { defineAsyncComponent, defineComponent, getCurrentInstance, onMounted, reactive, toRefs } from 'vue'
  import { attendAuditList, getRegisterConfigList, attendAudit } from '@/api/exhibitionManage'
  import { useRoute } from 'vue-router'
  import { parseTime } from '@/utils/index'
  export default defineComponent({
    name: 'UserManage',
    components: {
      Edit: defineAsyncComponent(() => import('./components/userDetail.vue')),
    },
    setup() {
      const { proxy } = getCurrentInstance()

      const state = reactive({
        labelPosition: `left`,
        editRef: null,
        list: [],
        listLoading: true,
        layout: 'total, sizes, prev, pager, next, jumper',
        total: 0,
        selectRows: '',
        showShop: false,
        counrtyList: [],
        keywod: '',
        checkUserList: [],
        reason: '',
        form: {
          reason: '',
        },
        dialogFormVisible1: false,
        size1: '30%',
        rules: {
          reason: [
            {
              required: true,
              message: '请填写驳回原因',
              trigger: 'blur',
            },
          ],
        },
        isSendMsg: true,
        queryForm: {
          pageNum: 1,
          pageSize: 10,
          usernameLike: '',
          identity: '',
          auditStatus: '',
          keyword: '',
          meetingCode: '',
          meetingType: 'EXHIBITION',
          isExistAuditPassForum: false,
        },
        statusList: {
          PENDING_REVIEW: '待审核',
          ACCEPT: `审核通过`,
          REFUSE: '审核不通过',
          CANCEL_SIGN: `取消报名`,
          NOT_REVIEW: `无需审核`,
        },
        userTypeList: [
          {
            name: '全部',
            key: '',
          },
          {
            name: '待审核',
            key: 'PENDING_REVIEW',
          },
          {
            name: '审核通过',
            key: 'ACCEPT',
          },
          {
            name: '审核不通过',
            key: 'REFUSE',
          },
          {
            name: '取消报名',
            key: 'CANCEL_SIGN',
          },
        ],
        officalCountList: [],
        reasonRef: null,
        identityMap: {},
      })

      const setSelectRows = (val) => {
        state.selectRows = val
      }
      const handleEdit = (row) => {
        state['editRef'].handleOpen(row)
      }
      const handleSizeChange = (val) => {
        state.queryForm.pageSize = val
        fetchData()
      }
      const handleCurrentChange = (val) => {
        state.queryForm.pageNum = val
        fetchData()
      }

      const route = useRoute()

      const queryData = () => {
        state.queryForm.pageNum = 1
        fetchData()
      }
      const handleQueryData = () => {
        fetchData()
      }

      const fetchData = async () => {
        state.listLoading = true
        try {
          const { data } = await attendAuditList(state.queryForm)
          if (data == null) {
            state.list = []
            state.total = 0
            return false
          }
          state.list = data.data
          state.total = data.total
        } catch (err) {
          proxy.$baseMessage(`查询失败`, 'error', 'vab-hey-message-error')
          state.list = []
          state.total = 0
        } finally {
          state.listLoading = false
        }
      }
      onMounted(async () => {
        state.queryForm.meetingCode = route.query.meetingCode
        state.queryForm.meetingType = route.query.meetingType || 'EXHIBITION'
        let { data: identityList } = await getRegisterConfigList(state.queryForm.meetingCode)
        state.officalCountList = [{ identity: '', name: '全部' }, ...identityList]
        state.identityMap = identityList.reduce((acc, item) => {
          acc[item.identity] = item.name
          return acc
        }, {})
        // state.queryForm.identity =
        //   identityList.length > 0 ? identityList[0].identity : 'AUDIENCE'
        fetchData()
      })

      const selectChange = (type, key) => {
        if (type == 'userType') {
          state.queryForm.auditStatus = key
        }
        if (type == 'officalCount') {
          state.queryForm.identity = key
        }
        if (type == 'isExistAuditPassForum') {
          state.queryForm.isExistAuditPassForum = key
        }
        state.queryForm.pageNum = 1
        fetchData()
      }

      const selectChangeBySwitch = () => {
        fetchData()
      }
      const handleSelectionChange = (e) => {
        state.checkUserList = e
      }

      const handleDate = (val) => {
        return parseTime(val)
      }

      const goBack = () => {
        proxy.$router.go(-1)
      }

      const refuse = async () => {
        state['reasonRef'].validate(async (valid) => {
          if (valid) {
            const audienceUid = state.checkUserList.map((v) => v.audienceUid)
            try {
              let parmas = {
                audienceUid: audienceUid,
                auditStatus: 'REFUSE',
                entranceCode: '',
                identity: state.queryForm.identity,
                meetingCode: state.queryForm.meetingCode,
                meetingType: state.queryForm.meetingCode.startsWith('MT') ? 'HOLD_MEETING' : 'EXHIBITION',
                reason: state.form.reason,
                isSendMsg: state.isSendMsg,
              }
              const { data } = await attendAudit(parmas)
              proxy.$baseMessage(`操作成功`, 'success', 'vab-hey-message-success')
            } catch (err) {
              console.log(err)
              proxy.$baseMessage(`操作失败`, 'error', 'vab-hey-message-error')
            }
            queryData()
            state.dialogFormVisible1 = false
            state.checkUserList = []
            state.form.reason = ''
            state['reasonRef']?.clearValidate?.()
          }
        })
      }
      const accept = async () => {
        const audienceUid = state.checkUserList.map((v) => v.audienceUid)
        try {
          let parmas = {
            audienceUid: audienceUid,
            auditStatus: 'ACCEPT',
            entranceCode: '',
            identity: state.queryForm.identity,
            meetingCode: state.queryForm.meetingCode,
            meetingType: state.queryForm.meetingCode.startsWith('MT') ? 'HOLD_MEETING' : 'EXHIBITION',
            reason: state.reason,
            isSendMsg: state.isSendMsg,
          }
          const { data } = await attendAudit(parmas)
          proxy.$baseMessage(`操作成功`, 'success', 'vab-hey-message-success')
        } catch (err) {
          proxy.$baseMessage(`操作失败`, 'error', 'vab-hey-message-error')
        }
        queryData()
        state.checkUserList = []
      }

      function getStatusColor(status) {
        return (
          '' +
          (status === 'PENDING_REVIEW'
            ? '#FFA500'
            : status === 'ACCEPT'
            ? '#4CAF50'
            : status === 'REFUSE'
            ? '#F44336'
            : status === 'CANCEL_SIGN'
            ? '#9E9E9E'
            : '#000000')
        )
      }

      return {
        ...toRefs(state),
        setSelectRows,
        selectChangeBySwitch,
        handleEdit,
        handleSizeChange,
        handleCurrentChange,
        queryData,
        fetchData,
        selectChange,
        handleSelectionChange,
        handleDate,
        goBack,
        accept,
        refuse,
        getStatusColor,
      }
    },
  })
</script>

<style lang="scss" scoped>
  .radioBox {
    display: flex;
    justify-content: flex-start;
    margin: 0;
    padding: 0;
    width: 100%;
    flex-wrap: wrap;

    li {
      list-style: none;
      margin-right: 20px;
      cursor: pointer;

      &.isChecked {
        color: #00c4c9;
      }
    }
  }
</style>
